export default "__VITE_ASSET__b9cb5e7d__"